import type { DiTypes } from "@iot-platform/core";

export const stationsTypes = Object.seal({
    repositories: {
        AlertRepository: Symbol.for("AlertRepository"),
        GraphRepository: Symbol.for("GraphRepository"),
        NotificationAlertRepository: Symbol.for("NotificationAlertRepository"),
        PestRepository: Symbol.for("PestRepository"),
        RouteRepository: Symbol.for("RouteRepository"),
        SensorGroupRepository: Symbol.for("SensorGroupRepository"),
        SpatialLevelRepository: Symbol.for("SpatialLevelRepository"),
        StationRepository: Symbol.for("StationRepository"),
        StationsRepository: Symbol.for("StationsRepository"),
    },
} satisfies DiTypes);
